import { create } from "zustand";

/**
 * Shell-level shared state for the IncidentStrip's per-incident dismissal
 * (R09). Mirrors useToasts / useAnnouncer — one module-level zustand store so
 * the IncidentStrip and the ShellVerdict can coordinate.
 *
 * Why shared: the IncidentStrip used to own `dismissedId` in component state,
 * but ShellVerdict suppresses itself whenever a critical is active. So
 * dismissing the strip during a still-active critical hid BOTH surfaces — the
 * page lost its in-flow verdict entirely. Lifting the dismissed id here lets
 * ShellVerdict fall through to its critical-tone segment ONLY when the strip
 * is actually dismissed, so a dismiss leaves the in-flow verdict standing.
 *
 * Keyed on the alarm id (not a boolean) so a NEW worst-critical (a different
 * top.id) re-shows the strip — an operator can't permanently mute a future,
 * possibly worse, incident.
 */
interface IncidentDismissedState {
  dismissedId: string | null;
  setDismissedId(id: string | null): void;
}

export const useIncidentDismissed = create<IncidentDismissedState>((set) => ({
  dismissedId: null,
  setDismissedId: (id) => set({ dismissedId: id }),
}));
